



















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';
import IQuestion from "@/components/icons/IQuestion.vue";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";
import Highcharts from "highcharts";
import {locales} from "@/helpers/locales";
import {colorsChart} from "@/helpers/colorsChart";

const auth = namespace('auth')

@Component({
  name: 'ChartColumnBar',
  components: {IQuestion, TooltipSimple, ChangeClicker}
})
export default class ChartColumnBar extends Vue {

  @Prop({type: Array || null, default: []}) items!: string[]
  @Prop({type: Number, default: 0}) answersSum!: number
  @Prop({type: Number, default: 0}) totalCount!: number
  @Prop({type: String, default: ''}) answersSumHelper!: string
  @Prop({type: String, default: ''}) title!: string
  @Prop({type: String || null, default: '250'}) width!: string
  @Prop({type: String || null, default: '250'}) height!: string
  @Prop({type: Array || null, default: []}) select!: [] | null
  @Prop({type: String || null, default: []}) defaultSelect!: string | null
  @Prop({type: String, default: ''}) titleY!: string | null
  @Prop({type: String, default: ''}) titleSeries!: string | null
  @Prop({type: String, default: 'center'}) alignClicker!: string | null

  opasity:number = 1
  typeDiagram = this.defaultSelect

  changeTypeDiagramm(type: string) {
    this.chartOptions.chart.type = type
    this.changeOptionChart()
  }

  get isMaxThenHundred() {
    return this.items.some((item: any) => {
      return item.y >= 96
    })
  }

  @Watch('currentLocale', {immediate: true})
  onLocaleChanged(_: any) {
    console.log('items', this.items)
    this.updateLocale()
  }

  get currentLocale() {
    return this.$i18n.locale
  }

  updateLocale() {
    Highcharts.setOptions({
      lang: {
        shortMonths: locales[this.currentLocale]
      }
    })
    this.chartOptions.series[0].name = this.$t('newstatistics.questionnaires.total_answers')
  }

  @Watch('items', {immediate: true, deep: true})
  getItems(NewVal: any) {
    this.chartOptions.series[0].data = NewVal
    this.changeOptionChart()
  }
  test(){
    alert('boom')
  }

  changeOptionChart() {
    switch (this.chartOptions.chart.type) {
      case 'bar':
        this.chartOptions.chart.height = this.items.length > 6 ? String(this.items.length * 30) : this.height
        this.chartOptions.xAxis.labels.rotation = 0
        this.chartOptions.chart.marginBottom = '50'
        this.chartOptions.series[0].data = this.items
        this.chartOptions.legend.enabled = false
        this.chartOptions.tooltip.enabled = true
        this.chartOptions.xAxis.labels.style.textAlign = 'right'
        break;
      case 'column':
        const data = this.items.slice(0)
        this.chartOptions.chart.height = this.height
        this.chartOptions.chart.marginBottom = '60'

        this.chartOptions.xAxis.labels.rotation = this.items.length > 8 ? 16 : 0
        this.chartOptions.xAxis.labels.style.textAlign = this.items.length > 10 ? 'left' : 'center'
        this.chartOptions.series[0].data = data.reverse()
        this.chartOptions.legend.enabled = false
        this.chartOptions.tooltip.enabled = true
        break;
      case 'pie':
        this.chartOptions.chart.height = this.height
        this.chartOptions.xAxis.labels.rotation = 0
        this.chartOptions.chart.marginBottom = '50'
        this.chartOptions.series[0].data = this.items
        this.chartOptions.legend.enabled = true
        break;

    }
  }


  chartOptions = {
    chart: {
      height: this.height,
      width: null,
      style: {"fontSize": "12px"},
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '15',
      marginBottom: '50',
      type: this.typeDiagram,
      events: {
        load:  function(event:any) {
          const chart:any = this
          if(chart.options.chart.type == 'pie'){


            chart.setTitle({
              useHTML:true,
              text: `<div style="color: #0A0A0A;width: 85px; height: 75px;text-align: center;" >
                 <div style="font-size: 14px;line-height: 14px;font-weight: 600;">${chart.series[0].name.replace(/\s/g, '<br>')}</div>
       <div style=" font-weight: 600;font-size: 32px;line-height: 42px;"> ${chart.series[0].userOptions.someText}</div>
      </div>` ,
              align: 'left',
              verticalAlign: 'middle',
              y: 30,
              x: 78,
              style: {
                // fontWeight: 'bold'
              },
            })

          }
        }
      }


    },
    colors:colorsChart,
    title: {
      text: ''
    },
    subtitle: {},
    credits: {
      enabled: false
    },
    tooltip: {
      enabled: true,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        zIndex: 500,
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip" style="z-index: 500!important;">' + '<span class="statistics-v4-tooltip-title">'
          + context.key +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.series.name + ': ' + '<strong>' + context.y + '</strong>' + ' (' + context.point.count + '%)' + '</span></div>'
      },
    },
    xAxis: {
      type: 'category',
      labels: {
        rotation: 0,
        useHTML: true,//Set to true
        style: {
          width: '300px',
          textAlign: this.typeDiagram === 'bar' ? 'right' :'left'
          // whiteSpace:'normal'//set to normal
        },
        step: 1,
        formatter: function () {//use formatter to break word.
          const context: any = this
          return '<div class="lab">' + context.value + '</div>';
        }
      }
    },
    yAxis: {
      startOnTick: false,
      endOnTick: true,
      maxPadding: 0.1,
      min: 0,
      allowDecimals: false,
      title: {
        text: ''
      },
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
    },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'left',
      verticalAlign: 'middle',
      floating: true,
      x: 300,
      y: 0,
      symbolPadding: 10,
      symbolWidth: 10,
      symbolHeight: 10,
      itemStyle: {
        backgroundColor: 'red',
        overflow: 'hidden',
        color: '#6b6969',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '400',
        fontFamily: 'Inter'
      },
      labelFormatter: function () {
        const context: any = this
        return `<div><span>${context.name}</span>
<span style="font-size: 9px;margin-left: 15px;color: #939494">[${context.y}]</span></div>`

      }
    },
    plotOptions: {
      column: {
        legend: {
          enabled: true
        },
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
      bar: {
        legend: {
          enabled: true
        },
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
      pie: {
        chart: {
          marginLeft: 120,

        },
        colors:colorsChart,
        dataLabels: {
          fillColor: 'white',
          crop: false,
          overflow: 'none',
          enabled: true,
          distance: -20,
          format: '{point.percentage:.0f}%',
          filter: {
            property: 'percentage',
            operator: '>',
            value: 4
          }
        },

        xAxis: {
          labels: {
            rotation: 90,
            style: {
              fontSize: '13px',
              fontFamily: 'Verdana, sans-serif'
            }
          }
        },
        showInLegend: true,
        cursor: 'pointer',
        startAngle: -180,
        endAngle: 180,
        center: ['100px', '67%'],
        size: '110%'
      },
    },
    series: [{
      someTitle:this.titleSeries,
      someText:this.totalCount,
      innerSize: '60%',
      name: this.$t('newstatistics.questionnaires.total_answers'),
      data: this.items
    }]
  }


}
